import React from "react";
import { Helmet } from "react-helmet-async";
import "./styles/AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-page_wrapper">
      <Helmet>
        <title>About Chai n Chill | Cozy Chai & Connection</title>
        <meta
          name="description"
          content="Learn about Chai n Chill — a cozy haven where people gather to connect over chai traditions from around the world."
        />
        <meta
          name="keywords"
          content="chai, tea shop, community, chill space, culture, masala chai"
        />
        <meta property="og:title" content="About Chai n Chill" />
        <meta
          property="og:description"
          content="Discover how Chai n Chill celebrates the rich traditions of chai and connection."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/about" />
        <meta
          property="og:image"
          content="https://yourdomain.com/images/chai-preview.jpg"
        />
      </Helmet>

      <div className="about-page">
        <h1>About Chai n Chill</h1>
        <p>
          At <strong>Chai n Chill</strong>, our vision is to create a cozy haven
          where people from all walks of life can gather, sip, and connect over
          a cup of chai. We celebrate the rich chai traditions of cultures
          around the world — from the spice-laced masala chai of South Asia to
          the herbal infusions of the Middle East, and the creamy blends enjoyed
          across the West. Our space is built on the idea that chai is more than
          just a drink — it’s a ritual, a conversation starter, and a moment of
          calm in a busy world. Whether you come for quiet reflection, warm
          connection, or cultural discovery, there's always a seat and a cup
          waiting for you.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;
